export default __webpack_public_path__ + "static/media/OrgChartEng.8f62635f.jpg";